import { Breadcrumb, Button, Space, Modal, Input, message, Form, Select, Popconfirm, Spin, Upload } from "antd"
import { useState, useRef, useContext, useEffect } from "react";
import { Link } from "react-router-dom"
import { DashboardOutlined, DeleteOutlined, EditOutlined, PlusSquareOutlined, UploadOutlined } from "@ant-design/icons"
import { MdOutlineLibraryBooks } from "react-icons/md";
import { FaSitemap } from "react-icons/fa";
import DataTable from "../../components/common/table";
import UploadButton from "../../components/common/uploadButton";
import Header from "../../components/dashboard/header";
import { useCreateBudgetItem, getBudgetItems, useDeleteBudgetItem, useUpdateItem, useGetAllBudgetItemsUnpaginated, useUploadItems } from "../../hooks/budgetItem/budgetItemQuery";
import { extractValueFromInputRef, scrollToTop } from "../../helpers/dom";
import RefreshContext from "../../context/refreshContext";
import {useGetAllBudgetCategories} from "../../hooks/budgetCategory/budgetCategoryQuery";
const eventBus = document;


const { Option } = Select;


const dispatchUpdateEvent = (e) => {
  const addEvent = new CustomEvent("subaccount:update", { detail: { subaccount: e } });
  // console.log(`Emitting event: ${addEvent.type} ${JSON.stringify(addEvent.detail)}`);
  eventBus.dispatchEvent(addEvent);
}


function BudgetItemEdit({ item, onUpdate }) {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [bhead, setBhead] = useState(item?.category?.id ?? null);
  const [allItems, setAllItems] = useState([])
  const [parent, setParent] = useState(null)
  const [budgetCategories, setBudgetCategories] = useState([])
  const showEditModal = () => setIsEditOpen(true);
  const hideEditModal = () => setIsEditOpen(false);

  const titleRef = useRef(null);
  const valueRef = useRef(null);

  const { flag, setFlag } = useContext(RefreshContext);
  const deleteBudgetItem = useDeleteBudgetItem();
  const updateBudgetItem = useUpdateItem();
  const getAllItems = useGetAllBudgetItemsUnpaginated()

  const fetchRecords = useGetAllBudgetCategories()

  const loadCategories = async () => {
    const data = await fetchRecords()
    setBudgetCategories(data)
}

  const loadAllItems = async () => {
    const data = await getAllItems()
    // set data
    const d = [{ id: null, title: 'Select parent' }]
    d.push(...data)
    setAllItems(d)
  }

  useEffect(() => {
    loadCategories().finally()
  }, []);

  useEffect(() => {
    if (isEditOpen) {
      loadAllItems().finally()
    }
  }, [isEditOpen])

  const confirmBudgetItem = async () => {
    const { message: response } = await deleteBudgetItem(item.id);
    message.success(response ?? "Item deleted successfully");
    setFlag(!flag);
    dispatchUpdateEvent()
  }

  const handleSubmit = async () => {
    const payload = {
      title: extractValueFromInputRef(titleRef),
      value: extractValueFromInputRef(valueRef),
      budgetCategory: bhead,
      parentId: parent ?? null
    }
    const { message: response } = await updateBudgetItem(item.id, payload);
    message.success(response ?? "Account type updated successfully");
    setIsEditOpen(false);
    setFlag(!flag);
    dispatchUpdateEvent()
    loadAllItems()
    onUpdate && onUpdate()
  }

  return (
    <>
      <Space size="small" wrap>
        <Button type="primary" onClick={showEditModal}>
          <EditOutlined />
          Edit
        </Button>
        <Popconfirm
          title="Delete this Subaccount item"
          description="Are you sure to delete this Subaccount item?"
          onConfirm={confirmBudgetItem}
          onCancel={() => null}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" danger>
            <DeleteOutlined />
            Delete
          </Button>
        </Popconfirm>
      </Space>
      <Modal title="Update Subaccount item" open={isEditOpen} footer={null} onCancel={hideEditModal}>
        <div style={{ marginTop: "3em" }}>
          <Form
            initialValues={{ ...item, head: item?.category?.id ?? null, parent: item?.parent?.id ?? null }}
            wrapperCol={{
              span: 24,
            }}>
            <Form.Item
              name="title"
              rules={[
                {
                  required: true,
                  message: 'Please input Subaccount item title!',
                },
              ]}>
              <Input.Group>
                <Input size="large" ref={titleRef} placeholder="Subaccount item Title" />
              </Input.Group>
            </Form.Item>
            <Form.Item
              name="value"
              rules={[
                {
                  required: true,
                  message: 'Please input Subaccount item value!',
                },
              ]}>
              <Input.Group>
                <Input size="large" ref={valueRef} placeholder="Subaccount item Value" />
              </Input.Group>
            </Form.Item>
            <Form.Item
              name="head"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select
                placeholder="Select a Account type"
                showSearch
                onChange={(e) => setBhead(e)}
              >
                {
                  budgetCategories.map((bh, idx) => (
                    <Option key={idx} value={bh.id}>{bh.title}</Option>
                  ))
                }
              </Select>
            </Form.Item>
            <Form.Item
              name="parent">
              <Select
                placeholder="Select a Parent if any"
                showSearch
                onChange={(e) => setParent(e)}
              >
                {
                  allItems.map((h, idx) => (
                    <Option key={idx} value={h.id}>{h.title}</Option>
                  ))
                }
              </Select>
            </Form.Item>
            <Form.Item
              wrapperCol={{
                span: 8,
                offset: 16
              }}
              className="submit-button-wrapper"
            >
              <Button style={{ backgroundColor: "green" }} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                Submit Changes
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  )
}


function NoDataComponent() {
  return (
    <h2>
      No data, Please select a Account type
    </h2>
  )
}



export default function BudgetItem() {
  const [isOpen, setIsOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [data, setData] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [bhead, setBhead] = useState("");
  const [parent, setParent] = useState(null)
  const [loading, setLoading] = useState(false);
  const [searchHead, setSearchHead] = useState(null);
  const [allItems, setAllItems] = useState([])

  const showCreateModal = () => setIsOpen(true);
  const hideCreateModal = () => setIsOpen(false);
  const getAllItems = useGetAllBudgetItemsUnpaginated()
  const [totalElements, setTotalElements] = useState(0)
  const [pageSize, setPageSize] = useState(10)

  const { flag, setFlag } = useContext(RefreshContext);

  const valueRef = useRef(null);
  const titleRef = useRef(null);

  const fetchRecords = useGetAllBudgetCategories()

  const loadCategories = async () => {
    const data = await fetchRecords()
    setBudgetCategories(data)
  }
  const [budgetCategories, setBudgetCategories] = useState([])
  const [uploadCategory, setUploadCategory] = useState(null)
  const createBudgetItem = useCreateBudgetItem();
  const uploadBudgetItems = useUploadItems();

  const handleHeadSearch = async (value, page, size) => {
    console.log(value, page)
    const req = value ? value : searchHead
    if (req) {
      setSearchHead(req)
      setPageSize(size ?? 10)
      setLoading(true)
      const result = await getBudgetItems(req, page ? page - 1 : 0, size ? size : 10);
      setData(result.content);
      setTotalElements(result.totalElements)
      setLoading(false);
    }
  }

  const loadAllItems = async () => {
    const data = await getAllItems()
    // set data
    const d = [{ id: null, title: 'Select parent' }]
    d.push(...data)
    setAllItems(d)
  }

  useEffect(() => {
    loadCategories().finally()
  }, []);


  useEffect(() => {
    eventBus.addEventListener("subaccount:update", e => {
      handleHeadSearch()
      loadAllItems()
    })
    loadAllItems()
    scrollToTop();
  }, []);



  const handleSubmit = async () => {
    const payload = {
      title: extractValueFromInputRef(titleRef),
      value: extractValueFromInputRef(valueRef),
      budgetCategory: bhead,
      parentId: parent ?? null
    }
    const { message: response } = await createBudgetItem(payload);
    message.success(response ?? "Subaccount item created successfully");
    setIsOpen(false);
    setFlag(!flag);
    dispatchUpdateEvent()
  }

  const handleUploadChange = async (form) => {
    const res = await uploadBudgetItems(form);
    message.success(res.message?? "Items uploaded successfully");
    setIsUploadOpen(false);
  }


  const budgetItemTableColumns = [
    {
      title: "S/N",
      key: "s/n",
      render: (_, __, idx) => idx + 1
    },
    {
      title: "Name",
      dataIndex: "title",
      key: "name"
    },
    {
      title: "Value",
      dataIndex: "code",
      key: "code"
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (_, { category }) => category?.title,
      key: "category"
    },
    {
      title: "Parent",
      dataIndex: "parent",
      render: (_, { parent }) => parent?.title ?? 'None',
      key: "parent"
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, item) => (
        <BudgetItemEdit item={item} onUpdate={() => handleHeadSearch()} />
      )
    }
  ]

  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">

          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <MdOutlineLibraryBooks />
                <Link to={"/dashboard"}>Configuration</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <FaSitemap />
                <Link to="/dashboard/subaccount-type">Sub account</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <div>
              <Select
                showSearch
                placeholder="Filter By Category"
                onChange={(e) => handleHeadSearch(e)}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{
                  width: "15em"
                }}
                options={[
                  ...budgetCategories.map(h => ({
                    value: h.id,
                    label: h.title
                  }))
                ]
                }
              />
            </div>

            <div style={{ display: 'flex', gap: '1em' }}>
              <Button style={{ backgroundColor: "blue", color: "#FFFFFF" }} onClick={() => setIsUploadOpen(true)}>
                <UploadOutlined />
                Upload Budget Items
              </Button>
              <Button style={{ backgroundColor: "green", color: "#FFFFFF" }} onClick={showCreateModal}>
                <PlusSquareOutlined />
                Create Subaccount
              </Button>
            </div>
          </div>
          <div className="table-section">
            <Spin spinning={loading}>
              <DataTable cols={budgetItemTableColumns} perPage={pageSize} onPageChange={(page, size) => handleHeadSearch(searchHead, page, size)} totalElements={totalElements} data={data} locale={{
                emptyText: <NoDataComponent />
              }} />
            </Spin>
          </div>
        </div>
      </div>
      <Modal title="Add Subaccount item" open={isOpen} footer={null} onCancel={hideCreateModal}>
        <div style={{ marginTop: "3em" }}>
          <Form
            wrapperCol={{
              span: 24,
            }}>
            <Form.Item
              name="item"
              rules={[
                {
                  required: true,
                  message: 'Please input Subaccount item title!',
                },
              ]}>
              <Input.Group>
                <Input size="large" placeholder="Subaccount item Title" ref={titleRef} />
              </Input.Group>
            </Form.Item>
            <Form.Item
              name="value"
              rules={[
                {
                  required: true,
                  message: 'Please input Subaccount item value!',
                },
              ]}>
              <Input.Group>
                <Input size="large" placeholder="Subaccount item Value" ref={valueRef} />
              </Input.Group>
            </Form.Item>
            <Form.Item
              name="head"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select
                placeholder="Select a Account type"
                showSearch
                onChange={(e) => setBhead(e)}
              >
                {
                  budgetCategories.map((h, idx) => (
                    <Option key={idx} value={h.id}>{h.title}</Option>
                  ))
                }
              </Select>
            </Form.Item>
            <Form.Item
              name="parent"
            >
              <Select
                placeholder="Select a Parent if any"
                showSearch
                onChange={(e) => setParent(e)}
              >
                {
                  allItems.map((h, idx) => (
                    <Option key={idx} value={h.id}>{h.title}</Option>
                  ))
                }
              </Select>
            </Form.Item>
            <Form.Item
              wrapperCol={{
                span: 8,
                offset: 16
              }}
              className="submit-button-wrapper"
            >
              <Button style={{ backgroundColor: "green" }} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                Create
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>

      <Modal
        title="Upload Budget Items"
        open={isUploadOpen}
        footer={null}
        onCancel={() => setIsUploadOpen(false)}
      >
        <div style={{ marginTop: "3em" }}>
          <Form
            labelCol={{
              span: 8
            }}
            wrapperCol={{
              span: 24,
            }}>
              <Button
                  style={{ width: '100%', marginBottom: '1em' }}
                  onClick={() => {
                    const headers = "SN,Name,Code,Parant Code\n";
                    const blob = new Blob([headers], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'template.csv';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                  }}
                >
                  Download Template
                </Button>
            <Form.Item
              name="category"
              rules={[
                {
                  required: true,
                  message: 'Please select a budget category!',
                },
              ]}>
              <Select
                placeholder="Select Budget Category"
                showSearch
                onChange={(e) => setUploadCategory(e)}
              >
                {
                  budgetCategories.map((h, idx) => (
                    <Option key={idx} value={h.id}>{h.title}</Option>
                  ))
                }
              </Select>
            </Form.Item>
            <Form.Item
              name="file"
              rules={[
                {
                  required: true,
                  message: 'Please select a file to upload!',
                },
              ]}>
              <Space direction="vertical" style={{ width: '100%', display: 'flex' }}>
                <Upload
                  accept=".csv"
                  beforeUpload={(file) => {
                    setUploadFile(file);
                    return false;
                  }}
                  maxCount={1}
                  style={{ width: '100%' }}
                >
                  <Button icon={<UploadOutlined />} block style={{ width: '100%' }}>
                    Select File
                  </Button>
                </Upload>
              </Space>
            </Form.Item>
            <Form.Item
              wrapperCol={{
                span: 8,
                offset: 16
              }}
              className="submit-button-wrapper"
            >
              <Button
                style={{ backgroundColor: "green" }}
                size="large"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  if (uploadCategory && uploadFile) {
                    const formData = new FormData();
                    formData.append('file', uploadFile);
                    formData.append('budgetCategory', uploadCategory);

                    handleUploadChange(formData);
                  } else {
                    message.error("Please select both a category and a file");
                  }
                }}
              >
                Upload
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  )
}
